/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

export class LegalServiceDecodeError extends Error {
  constructor(m?: string) {
    super(m);
    Object.setPrototypeOf(this, LegalServiceDecodeError.prototype);
  }
}

export class InvalidLocalizedPolicyData extends Error {
  constructor(m?: string) {
    super(m);
    Object.setPrototypeOf(this, InvalidLocalizedPolicyData.prototype);
  }
}

export class NoPolicyDataFound extends Error {
  constructor(m?: string) {
    super(m);
    Object.setPrototypeOf(this, NoPolicyDataFound.prototype);
  }
}
